const DESKTOP_BREAKPOINT = 782; // px — keep in sync with your CSS breakpoint

function initCarousel(root) {
	const viewport = root.querySelector(".prudential-carousel__viewport");
	const track = root.querySelector(".prudential-carousel__track");
	const nav = root.querySelector(".prudential-carousel__nav");
	const prevBtn = root.querySelector(".prudential-carousel__button--prev");
	const nextBtn = root.querySelector(".prudential-carousel__button--next");
	const dotsContainer = root.querySelector(
		".prudential-carousel__dots-wrapper",
	);

	if (!track) {
		return;
	}

	const slides = Array.from(track.children);
	let index = 0;
	let dots = [];

	// With exactly 2 slides, dots are only needed below the desktop
	// breakpoint — CSS hides them on desktop via this class.
	if (dotsContainer) {
		dotsContainer.classList.toggle("desktop-hide", slides.length <= 2);
	}

	const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

	const getVisibleSlides = () => (isDesktop() ? 2 : 1);

	const getMetrics = () => {
		const visible = getVisibleSlides();
		const slideWidth = slides[0] ? slides[0].getBoundingClientRect().width : 0;
		const gap = parseFloat(getComputedStyle(track).gap) || 0;
		const step = slideWidth + gap;
		const maxIndex = Math.max(slides.length - visible, 0);

		return { step, maxIndex, visible };
	};

	const buildDots = (maxIndex) => {
		if (!dotsContainer) {
			return;
		}

		const count = maxIndex + 1;

		// Only rebuild when the number of positions changes.
		if (dots.length === count) {
			return;
		}

		dotsContainer.innerHTML = "";
		dots = [];

		for (let i = 0; i < count; i++) {
			const dot = document.createElement("button");
			dot.type = "button";
			dot.className = "prudential-carousel__dot";
			dot.setAttribute("role", "tab");
			dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
			dot.addEventListener("click", () => {
				index = i;
				update();
			});
			dotsContainer.appendChild(dot);
			dots.push(dot);
		}
	};

	const updateDots = (maxIndex, needsNav) => {
		if (!dotsContainer) {
			return;
		}

		dotsContainer.hidden = !needsNav;

		dots.forEach((dot, i) => {
			const isActive = i === index;
			dot.classList.toggle("is-active", isActive);
			dot.setAttribute("aria-selected", isActive ? "true" : "false");
		});
	};

	const update = () => {
		const { step, maxIndex, visible } = getMetrics();

		// Show nav only when there are more slides than fit at this viewport.
		const needsNav = slides.length > visible;
		if (nav) {
			nav.hidden = !needsNav;
		}

		index = Math.min(Math.max(index, 0), maxIndex);

		buildDots(maxIndex);

		// One step per index, anchored flush left — no inset in navigation.
		const offset = -(index * step);
		track.style.transform = `translateX(${offset}px)`;

		if (prevBtn) prevBtn.disabled = index === 0;
		if (nextBtn) nextBtn.disabled = index === maxIndex;

		updateDots(maxIndex, needsNav);
	};

	if (prevBtn) {
		prevBtn.addEventListener("click", () => {
			index -= 1;
			update();
		});
	}

	if (nextBtn) {
		nextBtn.addEventListener("click", () => {
			index += 1;
			update();
		});
	}

	window.addEventListener("resize", update);
	update();
}

document
	.querySelectorAll(".wp-block-prudential-blocks-prudential-carousel")
	.forEach(initCarousel);
